import type {ReactElement} from 'react';
import React from 'react';
import {FillTypes} from '@PosterWhiteboard/classes/fill.class';
import {getColorFillTypeFromFillType} from '@Utils/color.util';
import type {ColorFillPropertyType} from '@Components/color-fill';
import type {RGBA} from '@Utils/color.util';
import {ColorFill} from '@Components/color-fill';

interface BottomBarItemColorFillProps {
  color: RGBA[];
  type?: FillTypes;
}

export function BottomBarItemColorFill({type = FillTypes.SOLID, ...props}: BottomBarItemColorFillProps): ReactElement {
  const getColors = (): RGBA[] | RGBA => {
    if (type === FillTypes.SOLID) {
      return props.color[0];
    }

    const colors = [];
    for (const eachColor of props.color) {
      colors.push(eachColor);
    }

    return colors.reverse();
  };

  const getType = (): ColorFillPropertyType | undefined => {
    return getColorFillTypeFromFillType(type);
  };

  return <ColorFill width={24} height={24} colorFillPropertyType={getType()} color={getColors()} />;
}
